export enum CalendarFirstDayOfWeek {
    SUNDAY = 0,
    MONDAY = 1,
}

export type CalendarFirstDayOfWeekType = CalendarFirstDayOfWeek;

export enum CalendarView {
    WEEK = 'dayGridWeek',
    MONTH = 'dayGridMonth',
    YEAR = 'multiMonthYear',
    PERIOD = 'dayGridCustom',
}

export type CalendarViewType = CalendarView;

export interface CalendarEvent<T extends object = object> {
    id: string;
    title: string;
    start: string | Date | null;
    end: string | Date | null;
    allDay?: boolean;
    extendedProps: T;
}
